import React from "react";
import PropTypes from "prop-types";

const InfoItem = ({ label, value }) => (
  <div className="mb-3">
    <small className="text-muted text-uppercase fw-semibold" style={{ fontSize: "0.75rem", letterSpacing: "0.05em" }}>
      {label}
    </small>
    <p className="mb-0 fw-medium">{value}</p>
  </div>
);

InfoItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
};

export function ConfirmJobCompletionDetails({ jobToComplete, confirmHandler }) {
  const { address } = jobToComplete;
  const addressLines = [
    address.address1,
    address.address2,
    address.address3,
    address.city,
    address.county,
    address.postcode,
  ].filter((line) => line && line.length > 0);

  return (
    <div className="row">
      <p className="lead">Complete this job?</p>
      <div className="col-xs-12 col-md-6">
        <div className="bg-light rounded p-3 mb-3">
          <p className="fw-bold mb-3 border-bottom pb-2">Customer Details</p>
          <InfoItem
            label="Customer Name"
            value={`${jobToComplete.name.firstName} ${jobToComplete.name.lastName}`}
          />
          <div className="mb-3">
            <small
              className="text-muted text-uppercase fw-semibold"
              style={{ fontSize: "0.75rem", letterSpacing: "0.05em" }}
            >
              Installation Address
            </small>
            <address style={{ fontStyle: "normal" }} className="mb-0">
              {addressLines.map((line, i) => (
                <p key={i} className="mb-0 fw-medium">
                  {line}
                </p>
              ))}
            </address>
          </div>
          <InfoItem
            label="Customer Contact Number"
            value={<a href={`tel:${jobToComplete.mobileNumber}`}>{jobToComplete.mobileNumber}</a>}
          />
          <InfoItem
            label="Customer Email"
            value={<a href={`mailto:${jobToComplete.email}`}>{jobToComplete.email}</a>}
          />
        </div>
      </div>
      <div className="col-xs-12 col-md-6">
        <div className="bg-light rounded p-3 mb-3">
          <p className="fw-bold mb-3 border-bottom pb-2">Boiler Details</p>
          <InfoItem
            label="Boiler"
            value={`${jobToComplete.boiler.make} ${jobToComplete.boiler.model}`}
          />
        </div>
      </div>
      <div className="text-end">
        <p className="me-3 fw-bold">Confirm job completion?</p>
        <button className="btn btn-success me-3" onClick={confirmHandler}>
          Yes and Continue
        </button>
      </div>
    </div>
  );
}

ConfirmJobCompletionDetails.propTypes = {
  jobToComplete: PropTypes.object.isRequired,
  confirmHandler: PropTypes.func.isRequired,
};
